import React from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';

// styles
import ModalStyles from "../../Dashboard/DashboardReuseAbleComponents/Modal.module.css"

const HomeModal = (props) => {
    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    // background: #000000;
                }

                .modal-content {
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'></Modal.Header>
                <Modal.Body dir='rtl'>
                    <div className='w-100 d-flex flex-column align-items-center justify-content-center py-2'>
                        <div className='w-100 d-flex flex-column justify-content-center align-items-center'>
                            <div className='my-3'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" fill="#E00000" className="bi bi-x-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                </svg>
                            </div>
                            <div className={`my-2 ${ModalStyles.title}`}>
                                لطفا ابتدا وارد حساب کاربری خود شوید.
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center align-items-center mb-3'>
                        {/* <Link to="/login">
                            <div className={`d-flex align-items-center justify-content-center me-3 ${ModalStyles.outlined_btn}`}>
                                ورود
                            </div>
                        </Link> */}

                        <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={props.onHide}>
                            باشه
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default HomeModal;